<template>
  <div>
    <div class="box box-success">
      <div class="box-header with-border">

        <h3 class="box-title box-title-sub"><img src="/static/img/icons/eri_ciclico.png"> ERI Cíclico</h3>
      </div>
      <div class="box-body">
        <div v-if="detailLayout">
          <div class="row">
            <div class="col-sm-3 leftChart">
              <div class="row">
                <div class="col-sm-12">
                  <chart-bar-eri :chart-data="barChartData" :width="50" :height="280"></chart-bar-eri>
                </div>
              </div>
              <br/>
              <div class="row">
                <div class="col-sm-12 text-center">
                  <i class="fa fa-tag" v-bind:style="formatAmountColor(this.fetchData.eriPercentageWarehouse)"></i>
                  <span class="span-value" v-bind:style="formatAmountColor(this.fetchData.eriPercentageWarehouse)">
                    {{(this.fetchData.eriPercentageWarehouse || 0) | formatDecimal}}%
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-9 chartPadding">
              <div class="row">
                <div class="col-sm-12">
                  <chart-line-eri :chart-data="lineChartData" :height="240"></chart-line-eri>
                </div>
              </div>
              <br/>
              <div class="row">
                <div class="col-sm-12">
                  <div style="width: 240px;" class="center-block">
                    <div style="width: 120px; border-right:1px solid #eee;" class="pull-left text-center">
                      <img src="/static/img/icons/ic_storage_arrived@3x.png" style="vertical-align: text-bottom" alt="Recibidos" height="20" width="20">
                      <span class="span-value" v-bind:style="formatAmountColor(this.fetchData.eriPercentageWarehouse)">
                        {{this.fetchData.skuSquareQuantityWarehouse | formatAmount}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                      </span>
                      <br/>
                      <span class="span-status">SKU Cant.</span>
                      <span class="span-status">Cuadradas</span>
                    </div>
                    <div style="width: 120px;" class="pull-right text-center">
                      <i class="fa fa-bullseye"></i>
                      <span class="span-value">
                        {{this.fetchData.skuInventoryQuantityWarehouse | formatAmount}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                      </span>
                      <br/>
                      <span class="span-status">SKU Cant.</span>
                      <span class="span-status">Inventariadas</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-12">
                  <chart-bar-eri :chart-data="barChartData" :width="50" :height="280"></chart-bar-eri>
                </div>
              </div>
              <br/>
              <div class="row">
                <div class="col-sm-12 text-center">
                  <i class="fa fa-tag" v-bind:style="formatAmountColor(this.fetchData.eriPercentageWarehouse)"></i>
                  <span class="span-value" v-bind:style="formatAmountColor(this.fetchData.eriPercentageWarehouse)">
                    {{(this.fetchData.eriPercentageWarehouse || 0) | formatDecimal}}%
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-8">
              <div style="width: 240px; padding-top:120px;" class="center-block">
                <div style="width: 120px; border-right:1px solid #eee;" class="pull-left text-center">
                  <img src="/static/img/icons/ic_storage_arrived@3x.png" style="vertical-align: text-bottom" alt="ERI" height="20" width="20">
                  <span class="span-value" v-bind:style="formatAmountColor(this.fetchData.eriPercentageWarehouse)">
                    {{this.fetchData.skuSquareQuantityWarehouse | formatAmount}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                  </span>
                  <br/>
                  <span class="span-status">SKU Cant.</span>
                  <span class="span-status">Cuadradas</span>
                </div>
                <div style="width: 120px;" class="pull-right text-center">
                  <i class="fa fa-bullseye"></i>
                  <span class="span-value">
                    {{this.fetchData.skuInventoryQuantityWarehouse | formatAmount}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                  </span>
                  <br/>
                  <span class="span-status">SKU Cant.</span>
                  <span class="span-status">Inventariadas</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>
import { mapGetters } from 'vuex'

import constants from 'assets/js/constants.js'
import util from 'assets/js/util.js'
import BarChart from 'charts/BarChart.js'
import LineChart from 'charts/LineChart.js'

export default {
  name: 'EriMain',
  props: [
    'mode',
    'fetchData'
  ],
  data () {
    return {
      barChartData: {},
      lineChartData: {}
    }
  },
  watch: {
    fetchData: function (newVal, oldVal) {
      this.fillData()
    }
  },
  computed: {
    ...mapGetters([
      'dashboardFilter'
    ]),
    detailLayout () {
      return this.showDetailLayout()
    }
  },
  created () {
  },
  mounted () {
    this.fillData()
  },
  methods: {
    fillData () {
      this.formatBarChart()

      if (this.showDetailLayout()) {
        this.formatLineChart()
      }
    },
    formatBarChart () {
      let skuSquare = this.fetchData.skuSquareQuantityWarehouse
      let skuInventory = this.fetchData.skuInventoryQuantityWarehouse

      let chartColors = util.getChartColors(this.fetchData.eriPercentageWarehouse)

      if (skuSquare === 0 && skuInventory === 0) {
        this.barChartData = {
          datasets: [
            {
              label: 'Sin Data',
              backgroundColor: chartColors.opaque,
              borderWidth: 1,
              data: [100],
              xAxisID: 'bar-x-axis1'
            }
          ]
        }
      } else {
        this.barChartData = {
          datasets: [
            {
              label: 'Cuadrado',
              backgroundColor: chartColors.solid,
              borderWidth: 1,
              data: [skuSquare],
              xAxisID: 'bar-x-axis1'
            },
            {
              label: 'Inventariado',
              backgroundColor: chartColors.opaque,
              borderWidth: 1,
              data: [skuInventory],
              xAxisID: 'bar-x-axis1'
            }
          ]
        }
      }
    },
    formatLineChart () {
      let chartColors = util.getChartColors(this.fetchData.eriPercentageWarehouse)

      this.lineChartData = {
        labels: util.getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.skuSquareQuantitiesWarehouse),
            label: 'Cuadrado',
            borderColor: chartColors.solid,
            fill: false
          },
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.skuInventoryQuantitiesWarehouse),
            label: 'Inventariado',
            borderColor: constants.colorPalette.Projected,
            fill: false
          }
        ]
      }
    },
    formatAmountColor (percentage) {
      let style = {
        color: util.getChartColors(percentage).solid
      }

      return style
    },
    showDetailLayout () {
      if (this.mode === constants.dashboardFilterModes.today) {
        return false
      } else {
        return true
      }
    }
  },
  components: {
    'chart-bar-eri': BarChart,
    'chart-line-eri': LineChart
  }
}
</script>



// WEBPACK FOOTER //
// EriMain.vue?4588f430